import React from 'react';
import Text from '../../../../ui/Text/Text';

import './team.scss';

import icon1 from '../../../../assets/media/icons/noun-badge.svg';
import icon1Light from '../../../../assets/media/icons/noun-badge-light.svg';
import icon1Dark from '../../../../assets/media/icons/noun-badge-dark.svg';
import icon2 from '../../../../assets/media/icons/noun-computer.svg';
import icon2Light from '../../../../assets/media/icons/noun-computer-light.svg';
import icon2Dark from '../../../../assets/media/icons/noun-computer-dark.svg';
import icon3 from '../../../../assets/media/icons/noun-management.svg';
import icon3Light from '../../../../assets/media/icons/noun-management-light.svg';
import icon3Dark from '../../../../assets/media/icons/noun-management-dark.svg';
import sectionImageBig from '../../../../assets/media/teamSection/team-section-image.png';
import Image from '../../../../ui/Image/Image';
import { ThemeEnum } from '../../../../utils/enums';
import { useAccessibility } from '../../../../contexts/AccessibilityContext';

type TConfigItem = {
  name: string;
  title: string;
  description: string;
  image: Record<ThemeEnum, string>;
};

const config: TConfigItem[] = [
  {
    image: { [ThemeEnum.Basic]: icon3, [ThemeEnum.Light]: icon3Light, [ThemeEnum.Dark]: icon3Dark },
    title: 'Управление',
    description: 'Инновационные методы управления с применением цифровых технологий.',
    name: 'management',
  },
  {
    image: { [ThemeEnum.Basic]: icon1, [ThemeEnum.Light]: icon1Light, [ThemeEnum.Dark]: icon1Dark },
    title: 'Методисты',
    description: 'В школе работают профессионалы с научно-методическим опытом.',
    name: 'methodists',
  },
  {
    image: { [ThemeEnum.Basic]: icon2, [ThemeEnum.Light]: icon2Light, [ThemeEnum.Dark]: icon2Dark },
    title: 'Платформа',
    description: 'Платформа SkyBox и цифровые материалы обеспечивают эффективный способ обучения.',
    name: 'platform',
  },
];

interface TeamProps {
  id?: string;
}

function Team({ id }: TeamProps) {
  const { settings } = useAccessibility();

  return (
    <section className='team' id={id}>
      <Text variant='h3' fontWeight={600} className='title'>
        Команда
      </Text>
      <div className='container'>
        <div className='team-holder'>
          <div className='image-frame'>
            {/* TODO: Add small image for smaller devices */}
            <Image src={sectionImageBig} alt='' />
          </div>
          <div className='items-wrapper'>
            {config.map((item, index) => {
              const { image, title, description, name } = item;
              return (
                <div className='item' key={index}>
                  <div className={`item-image-frame ${name}`}>
                    <img src={image[settings.theme]} className='item-image' alt='' />
                  </div>
                  <div className='texts'>
                    <p className='title'>{title}</p>
                    <p className='description'>{description}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Team;
